import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const updatePurposeTodo = createAsyncThunk('updatePurpose', async (data) => {
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL + `purpose/${data?.id}`,
            data: {
                "name": data.purpose,
                "status": data.status,
                "type": data.type,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('token')
            }
        });

        return res

    } catch (error) {
        return error?.response
    }
});


